{
  "fr": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "Les plaintes pour spam ne peuvent pas être réactivées ici. Cela ne peut être fait que manuellement via {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Recherche",
      "selected": "Selectionnés"
    }
  }
}
